import AdvanceConsumerReportPermissionScreen from 'features/advance/screens/lightning/AdvanceConsumerReportPermission/AdvanceConsumerReportPermission';
import React from 'react';

const CraUpgradePage = () => {
  return <AdvanceConsumerReportPermissionScreen />;
};

export default CraUpgradePage;
